<div class="quantity">
  <input type="number" min="1" max="9" step="1" value="1" />
</div>
<script></script>
X
